import { render } from "./HeroiconsSolidCheckCircle.vue?vue&type=template&id=f5fd9cbe"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCheckCircle.vue"]])

export default __exports__